import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { JobsContainer } from "./containers/JobsContainer";

const routes = () => (
  <Routes>
    <Route index element={<PageWithPermission component={<JobsContainer />} permissions={[Permission.ADMIN_JOBS]} />} />
    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
